import type { ShipmentOrder } from "./shipment-order";
import type { ShipmentProvider } from "./shipment-provider";

type Shipment = ShipmentOrder | ShipmentProvider;

const isShipmentProvider = (s: Shipment): s is ShipmentProvider => {
    return s.shipmentType === "SHIPMENT_PROVIDER";
};

export type { Shipment };
export { isShipmentProvider };
